import * as React from "react"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import { getArticleContentLocale, getLocalizedAlternates } from "../../../seo/localized-routes"

const SEO = ({ location, pageContext }) => {
  const data = useStaticQuery(graphql`
    query LocalizationSEOQuery {
      site {
        siteMetadata {
          siteUrl
        }
      }
    }
  `)
  const siteUrl = data.site.siteMetadata.siteUrl
  const locale = pageContext.frontmatter
    ? getArticleContentLocale(pageContext.frontmatter)
    : pageContext.locale || "en"
  const alternates = getLocalizedAlternates(location.pathname, siteUrl)
  const normalizedPath = location.pathname.replace(/\/+$/, "") || "/"
  const isRecruitingPage = /^(\/es)?\/(careers(?:-(?:android|marketing|video-editor))?|trabaja-con-nosotros)$/.test(normalizedPath)
  const isEnglishLegalPage = normalizedPath === "/privacy-policy" || normalizedPath === "/terms-of-service"

  return (
    <Helmet>
      <html lang={locale} />
      {alternates && <link rel="alternate" hrefLang="x-default" href={alternates.en} />}
      {alternates && <link rel="alternate" hrefLang="en" href={alternates.en} />}
      {alternates && <link rel="alternate" hrefLang="es" href={alternates.es} />}
      {isRecruitingPage && alternates && (
        <link rel="canonical" href={locale === "es" ? alternates.es : alternates.en} />
      )}
      {isEnglishLegalPage && <link rel="canonical" href={`${siteUrl}${normalizedPath}`} />}
      <meta property="og:locale" content={locale === "es" ? "es_ES" : "en_US"} />
      {alternates && (
        <meta
          property="og:locale:alternate"
          content={locale === "es" ? "en_US" : "es_ES"}
        />
      )}
    </Helmet>
  )
}

export { SEO }
